module.exports = __webpack_public_path__ + "img/calendar.a4e8b471.svg";